module.exports = __webpack_public_path__ + "Roboto-Medium.c54f2a3ee42d2a58d82f.ttf";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-Medium.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Medium.ttf
// module chunks = styles